module.exports = __webpack_public_path__ + "0f4382b5.png";